import { ClienteModel } from '../cliente.model';
import { FincasModel } from '../form-common/fincas.module';
import { ParcelasModel } from '../form-common/parcelas.model';
import { MantenimientoModel } from '../trabajadores/mantenimiento.model';
import { TratamientosModel } from '../tratamientos/tratamientos.model';
import { TareasBioModel } from './tareas-bio.model';

export class TareaFitoModel {
    [key: string]: 
        number | 
        string | 
        string[] | 
        boolean | 
        Date | 
        FincasModel | 
        ClienteModel | 
        {dia: number, mes: number, anyo: string} | 
        TareasBioModel[] |
        MantenimientoModel[] |
        ParcelasModel[] |
        TratamientosModel |
        null
    id?: '';
    id_cliente?: string;
    id_usuario?: string;
    id_finca?: any;
    id_sector?: any;
    ids_parcelas?: any;
    id_maquinaria?: any;
    ids_trabajadores?: any;

    fecha_inicio?: Date | string | null;
    fecha_fin?: string | null;
    fecha_caducidad?: string;
    hora_inicio?: string | null;
    hora_fin?: Date | string | null;
    horas_totales?: string;

    activo?: string | boolean;
    aplicado?: string | boolean;
    validado?: string | boolean;
    mochila?: string | boolean;

    referencia_usuario?: string;
    referencia_receta?: string;
    orden_asesor?: boolean;
    finca?: string;
    finca_localidad?: string;
    finca_asociada?: FincasModel;
    sector?: string;
    partida?: string;
    cliente?: ClienteModel;
    cliente_nombre?: string;
    cliente_email?: string;
    cliente_nif?: string;
    cliente_telefono?: string;
    usuario_nombre?: string;
    usuario_firma?: string;
    usuario_nif?: string;
    usuario_ropo?: string;
    parcelas_nombres?: string;
    superficie_parcelas?: number;
    variedades?: string[];
    tratamiento_nombre?: string;
    anyo?: number;
    fecha_completa?: string;
    fecha_hoy?: string;
    fecha_objeto?: {dia: number, mes: number, anyo: string};
    campanya_citricola?: string;
    caldo_aplicado?: number;
    litros?: number;
    litros_aplicados_ha?: number;
    bios?: TareasBioModel[];
    ropo?: string;
    agentes?: string[];
    observaciones?: string;
    cubeto_evaporacion?: boolean | string;
    punto_carga?: boolean | string;
    maquinaria?: string;
    capacidad_maquina?: number;
    marcha?: string;
    rpm?: string;
    presion?: string;
    boquillas?: string;
    velocidad?: string;
    tipo_maquina?: string;
    mano_obra?: number | string;
    desplazamiento?: string;
    trabajadores_nombres?: string;
    trabajadores?: MantenimientoModel[];
    tipo_plaga?: string;
    motivo?: string;
    ph_caldo?: string;
    eficacia?: string | null;
    cubas_totales?: string;
    motivo_justificacion?: string;
    epi?: string;
    momento_aplicacion?: string;
    coste_tratamiento?: string;
    soleado?: string;
    temperatura?: number;
    hr?: number;
    viento?: number;
    clima?: string;
    precip?: number;
    fecha_recoleccion?: string;
    litros_sobrante?: string;
    limpieza_epis?: boolean | string;
    dia_limpieza?: string;
    dia_tratamiento?: string;
    it?: string;

    parcelas?: ParcelasModel[];
    parcelas_superficie?: number;
    tratamiento?: TratamientosModel;
    id_tratamiento?: string | null;
    signature_img?: string;
    notas_cliente?: string;
    imagen?: string;
    image_after?: string;
    litros_aplicados?: number;
    ids_productos?: string;
    productos_nombres?: string;
    litros1?: string;
    litros2?: string;
    litros3?: string;
    orden_trabajo?: string;
    tipoMaquina?: string;

    facturado?: boolean | string;
    factura_albaran?: string;
    climatologia?: string;
    fecha_seca_cultivo_agua?: string;
    fin_fecha?: string;
    estado_tarea?: string;
    empresa_pagadora?: string;
    sup_tratada?: string;
    id_ref_usuario?: string;

    cultivo?: string;
    variedad?: string;
    sup_cultivada?: number | string;
}